import { create } from 'zustand'

interface BrazeState {
  appboy: any
  setAppboy: (appboy: any) => void
}

const useBrazeStore = create<BrazeState>((set) => ({
  appboy: null,
  setAppboy: (appboy) => set({ appboy }),
}))

export default useBrazeStore
